/*
 * Copyright (c) 2022-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */
import {Notification} from "./Notification.jsx";
import {Util} from "./Utilities.js";
import {ErrorHandler} from "./ErrorHandling.js";
import {ReconnectingWebSocket} from "./libraries/ReconnectingWebSocket.js";
import CurrentUser from "authClient/currentUser";
import Strings from "toolbox/strings";
import Unique from "toolbox/unique";
import Time from 'toolbox/time';
import Objects from "toolbox/objects";

let socketConnection = null

let currentSubscription = []
let currentCallbacks = {}

setInterval(() => {

    // console.log(currentSubscription);
}, 10000)

// every 20min send a new auth token to the server to keep the connection alive
setInterval(async () => {
    await Socket.updateAuthToken()

}, 10 * 60 * 1000) // 10 min

const Socket = function () {


    async function connect() {

        let authToken = await CurrentUser.getAuthToken()

        // Create a WebSocket connection.
        const socket = new ReconnectingWebSocket(import.meta.env.VITE_APP_LIVE_DATA_WS_ENDPOINT + "socket?authToken=" + authToken);

// on connection opened
        socket.on('open', (event) => {
            console.log('The socket has been connected');
            socketConnection = socket

            currentSubscription.forEach(subscription => {
                userBus(subscription, true);
            });

        });

// Handle reconnect logic - use the open event with isReconnect flag
        socket.on('open', async (event) => {
            if (event?.isReconnect) {
            }
        });

        socket.on('error', (err) => {
            Notification.createError("The socket has encountered an error", `connect_error due to ${err.message}`);
        });

        socket.on('message', (message) => {
            let [topic, payload] = JSON.parse(message);
            // let dif3 = Util.time.now() - (payload?.time ?? 0);
            // console.log(dif3);
            Object.values(currentCallbacks).map(element => {
                element.callback(topic, payload);
            });
        });

        async function updateAccessToken() {
            // update the JWTToken to a new current token
            let accessToken = await CurrentUser.getAuthToken()
            socket.url = import.meta.env.VITE_APP_LIVE_DATA_WS_ENDPOINT + "socket?authToken=" + accessToken;
        }

        setInterval(async () => {
            await updateAccessToken()
        }, 15000)

        const visibilityHandler = async () => {
            if (document.visibilityState === 'visible') {
                await updateAccessToken()
            }
        };

        document.addEventListener('visibilitychange', visibilityHandler);
    }


    function emit(eventName, value) {
        if (!Strings.isEmpty(socketConnection)) {
            socketConnection.send(JSON.stringify([eventName, value]));
        } else {
            setTimeout(() => {
                emit(eventName, value)
            }, 50)
        }
    }

    /**
     * Send a new auth token to the socket to keep the connection alive
     * @returns {Promise<void>}
     */
    async function updateAuthToken() {
        if (!Strings.isEmpty(socketConnection)) {
            let accessToken = await CurrentUser.getAuthToken()
            emit("user", {type: "authRefresh", authToken: accessToken})
        }
    }


    async function userBus(value, isReconnect = false) {
        if (!Strings.isEmpty(socketConnection)) {
            // recorde the request to request it agan if the socke server dose brake
            if (value.type === "requestStream" && !isReconnect) {

                let existingIndex = currentSubscription.findIndex((item) => {
                    return (item.tableName === value.tableName && Objects.areEqual(item.filter, value.filter))
                })
                if (existingIndex !== -1) {
                    return
                }
                currentSubscription.push({...value})

            }
            // if a stream is cancelt, remove it from the of subscriptions
            if (value.type === "cancelStream" && !isReconnect) {
                currentSubscription = currentSubscription.filter((item) => {
                    return !(item.tableName === value.tableName && Objects.areEqual(item.filter, value.filter))
                })
            }

            emit("user", value)
        } else {
            setTimeout(() => {
                userBus(value, isReconnect).then()
            }, 50)
        }
    }

    async function subscribeToUserBus(callback) {
        return subscribe("user", callback)
    }


    async function subscribe(eventName, callback) {
        if (!Strings.isEmpty(socketConnection)) {
            let subId = Unique.newInternalId();
            currentCallbacks[subId] = {
                callback: async (topic, message) => {
                    if (eventName === topic) {
                        callback(message);
                    }
                }
            };

            return {
                subId: subId,
                cancel: async () => {
                    delete currentCallbacks[subId];
                }
            };
        } else {
            await Time.sleep(50)
            return subscribe(eventName, callback)

        }
    }

    function subscribeOnce(eventName, callback) {
        if (!Strings.isEmpty(socketConnection)) {
            let subId = Unique.newInternalId();

            currentCallbacks[subId] = {
                callback: async (topic, message) => {
                    if (!Object.keys(currentCallbacks).includes(subId)) {
                        ErrorHandler.recordError("The callback does not longer exist but it was fired again");
                        return
                    }

                    if (eventName === topic) {
                        // remove callback after a first message
                        await callback(message);
                        delete currentCallbacks[subId];
                    }
                }
            };

            return {
                cancel: () => {
                    delete currentCallbacks[subId];
                }
            }
        } else {
            setTimeout(() => {
                subscribeOnce(eventName, callback)
            }, 50)
        }
    }

    function applyChange(inputArray = [], change) {
        if (change.changeType === "remove") {
            if (Array.isArray(inputArray)) {
                inputArray = inputArray.filter(item => {
                    return (item?.indexKey !== change?.data?.indexKey)
                })
            } else {

                let newObject = Object.values(inputArray).filter(item => {
                    return (item.indexKey !== change.data.indexKey)
                })

                inputArray = Util.arrays.reduceToObject(newObject.map(item => ({[item.indexKey]: item})))
            }

            // remove deleted elements from selection

        } else if (change.changeType === "insert" || change.changeType === "update") {
            // sometimes the update is send without a row existing than it shoud be added
            // to exist check is needed one insert can be sent multiple times
            let doesExist = false
            if (Array.isArray(inputArray)) {
                let index = inputArray.findIndex(row => (row?.indexKey === change?.data?.indexKey))
                if (index !== -1) {
                    // update existing
                    inputArray[index] = {...inputArray[index], ...change.data}
                } else {
                    // add new
                    inputArray.push(change.data)
                }
            } else {

                inputArray = Util.arrays.reduceToObject(Object.values(inputArray).map(row => {
                    if (row?.indexKey === change?.data?.indexKey) {
                        doesExist = true
                        return {[row.indexKey]: {...row, ...change.data}}
                    } else {
                        return {[row.indexKey]: row}
                    }
                }))

                if (!doesExist) {
                    inputArray[change.data.indexKey] = change.data
                }
            }
        }
        return inputArray
    }


    return {
        connect: connect,
        emit: emit,
        subscribe: subscribe,
        userBus: userBus,
        subscribeToUserBus: subscribeToUserBus,
        applyChange: applyChange,
        updateAuthToken: updateAuthToken,
        subscribeOnce: subscribeOnce
    }
}()


export {
    Socket, currentCallbacks, currentSubscription
};



